import React from "react";
import { HC } from "../hr/theme";
import client from "../../lib/api";
import { toast } from "sonner";

export const SEV_TONE = {
  critical: [HC.red, HC.redTint], high: [HC.amber, HC.amberTint],
  medium: [HC.blue, HC.blueTint], low: [HC.muted, HC.borderSoft],
};
export const sevTone = (s) => SEV_TONE[s] || [HC.muted, HC.borderSoft];

export const Sev = ({ value, testid }) => {
  const [c, bg] = sevTone(value);
  return (
    <span data-testid={testid} className="inline-flex items-center text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide"
      style={{ background: bg, color: c }}>{value || "—"}</span>
  );
};

export const Delta = ({ pct, invert = false, unit = "%" }) => {
  if (pct === null || pct === undefined) return <span className="text-xs" style={{ color: HC.soft }}>no prior data</span>;
  const good = invert ? pct <= 0 : pct >= 0;
  return (
    <span className="text-xs font-semibold" style={{ color: good ? HC.green : HC.red }}>
      {pct >= 0 ? "▲" : "▼"} {Math.abs(pct)}{unit} vs prior
    </span>
  );
};

export const KpiCard = ({ label, value, sub, delta, invert, accent = HC.burgundy, Icon, onClick, testid }) => (
  <div data-testid={testid} onClick={onClick}
    className={`rounded-2xl bg-white border p-4 flex flex-col gap-2 transition-shadow ${onClick ? "cursor-pointer hover:shadow-[0_6px_20px_rgba(59,34,34,0.07)]" : ""}`}
    style={{ borderColor: HC.border }}>
    <div className="flex items-start justify-between gap-2">
      <span className="text-[10px] font-bold tracking-[0.14em] uppercase" style={{ color: HC.soft }}>{label}</span>
      {Icon && (
        <span className="w-8 h-8 rounded-xl flex items-center justify-center shrink-0" style={{ background: `${accent}14` }}>
          <Icon size={15} style={{ color: accent }} />
        </span>
      )}
    </div>
    <div className="font-brand font-bold text-[24px] leading-none tabular-nums" style={{ color: HC.text }}>{value}</div>
    {sub && <div className="text-xs" style={{ color: HC.muted }}>{sub}</div>}
    {delta !== undefined && <Delta pct={delta} invert={invert} />}
  </div>
);

export async function download(url, filename) {
  try {
    const res = await client.get(url, { responseType: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(res.data);
    a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
  } catch (e) {
    toast.error("Export failed");
  }
}

export const Spinner = ({ text = "Loading…" }) => (
  <div className="py-16 text-center text-sm" style={{ color: HC.soft }} data-testid="mgmt-loading">{text}</div>
);

export const Tabs = ({ tabs, value, onChange, testid }) => (
  <div className="flex items-center gap-2 overflow-x-auto pb-1" data-testid={testid}>
    {tabs.map(([v, l]) => (
      <button key={v} onClick={() => onChange(v)} data-testid={`${testid}-${v}`}
        className="h-9 px-3.5 rounded-full text-[13px] font-semibold whitespace-nowrap border transition-colors"
        style={value === v
          ? { background: HC.burgundy, color: "#fff", borderColor: HC.burgundy }
          : { background: "#fff", color: HC.text, borderColor: HC.border }}>
        {l}
      </button>
    ))}
  </div>
);
